import React from 'react';
import { motion } from 'framer-motion';
import { Plane, GraduationCap, Sparkles, Building2 } from 'lucide-react';

/**
 * Live activity ticker — auto-scrolling marquee of recent student activity.
 * Updates pull from /app/frontend/src/data/successStories.js → `liveActivity`.
 */
const LiveActivityTicker = ({ items }) => {
  // Duplicate items twice for seamless infinite scroll
  const repeated = [...items, ...items];

  return (
    <div
      className="relative w-full overflow-hidden bg-gradient-to-r from-[#0B2545] via-[#13315C] to-[#0B2545] border-y border-white/10"
      data-testid="live-ticker"
    >
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#0B2545] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#0B2545] to-transparent z-10 pointer-events-none" />

      {/* "Live" badge */}
      <div className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 z-20 flex items-center gap-1 md:gap-1.5 px-1.5 md:px-2 py-0.5 rounded-full bg-[#E63946]/20 border border-[#E63946]/40">
        <span className="w-1.5 h-1.5 rounded-full bg-[#E63946] animate-pulse" />
        <span className="text-[9px] md:text-[10px] uppercase tracking-wider font-bold text-[#FF6B6B]">Live</span>
      </div>

      <motion.div
        className="flex gap-8 py-2.5 whitespace-nowrap"
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
      >
        {repeated.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2 text-xs md:text-sm text-white/85 flex-shrink-0">
            <span className="text-base">{item.emoji}</span>
            <span>{item.text}</span>
            <span className="text-[#4DD4AC] ml-2">·</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default LiveActivityTicker;
